export default "__VITE_ASSET__s9lEx238__"